import React from 'react';
import './cta.css';

const CTA = () => (
  <div className="gpt3__cta">
    <div className="gpt3__cta-btn">
      <div className="row">
        <div className="col-md-2">
          <button type="button">Get Started</button>
        </div>
        <div className="col-md-2">
          <button type="button">Get Started</button>
        </div>
        <div className="col-md-2">
          <button type="button">Get Started</button>
        </div>
        <div className="col-md-2">
          <button type="button">Get Started</button>
        </div>
        <div className="col-md-2">
          <button type="button">Get Started</button>
        </div>
        <div className="col-md-2">
          <button type="button">Get Started</button>
        </div>
      </div>
    </div>
  </div>
);

export default CTA;
